import AssetsBase from '@/modules/assets/components/AssetsBase'
import AssetsDashboard from '@/modules/assets/views/Dashboard'
import AllServices from '@/modules/assets/views/services/All'
import ServiceDetailBase from '@/modules/assets/views/services/detail/Base'
import ServiceDetailOverview from '@/modules/assets/views/services/detail/Overview'
import AllInventory from '@/modules/assets/views/inventory/All'
import InventoryDetailBase from '@/modules/assets/views/inventory/detail/Base'
import InventoryDetailOverview from '@/modules/assets/views/inventory/detail/Overview'
import AllLabour from '@/modules/assets/views/labour/All'
import LabourDetailBase from '@/modules/assets/views/labour/detail/Base'
import LabourDetailOverview from '@/modules/assets/views/labour/detail/Overview'
import AllVehicles from '@/modules/assets/views/vehicles/All'
import VehicleDetailBase from '@/modules/assets/views/vehicles/detail/Base'
import VehicleDetailOverview from '@/modules/assets/views/vehicles/detail/Overview'
import AllEquipment from '@/modules/assets/views/equipment/All'
import EquipmentDetailBase from '@/modules/assets/views/equipment/detail/Base'
import EquipmentDetailOverview from '@/modules/assets/views/equipment/detail/Overview'
import store from '@/store'

const routes = [
  {
    path: '/assets/',
    component: AssetsBase,
    meta: { appKey: 'assets' },
    children: [
      {
        path: 'dashboard',
        name: 'AssetsDashboard',
        component: AssetsDashboard,
        beforeEnter: (to, from, next) => {
          store.dispatch('clearSubnav')
          next()
        }
      },
      {
        path: 'services',
        name: 'AllServices',
        component: AllServices,
        beforeEnter: (to, from, next) => {
          store.dispatch('clearSubnav')
          next()
        }
      },
      {
        path: 'service-item/:id',
        component: ServiceDetailBase,
        children: [
          {
            path: 'overview',
            name: 'ServiceDetailOverview',
            component: ServiceDetailOverview
          }
        ]
      },
      {
        path: 'inventory',
        name: 'AllInventory',
        component: AllInventory,
        beforeEnter: (to, from, next) => {
          store.dispatch('clearSubnav')
          next()
        }
      },
      {
        path: 'inventory-item/:id',
        component: InventoryDetailBase,
        children: [
          {
            path: 'overview',
            name: 'InventoryDetailOverview',
            component: InventoryDetailOverview
          }
        ]
      },
      {
        path: 'labour',
        name: 'AllLabour',
        component: AllLabour,
        beforeEnter: (to, from, next) => {
          store.dispatch('clearSubnav')
          next()
        }
      },
      {
        path: 'labour-item/:id',
        component: LabourDetailBase,
        children: [
          {
            path: 'overview',
            name: 'LabourDetailOverview',
            component: LabourDetailOverview
          }
        ]
      },
      {
        path: 'vehicles',
        name: 'AllVehicles',
        component: AllVehicles,
        beforeEnter: (to, from, next) => {
          store.dispatch('clearSubnav')
          next()
        }
      },
      {
        path: 'vehicle/:id',
        component: VehicleDetailBase,
        children: [
          {
            path: 'overview',
            name: 'VehicleDetailOverview',
            component: VehicleDetailOverview
          }
        ]
      },
      {
        path: 'equipment',
        name: 'AllEquipment',
        component: AllEquipment,
        beforeEnter: (to, from, next) => {
          store.dispatch('clearSubnav')
          next()
        }
      },
      {
        path: 'equipment/:id',
        component: EquipmentDetailBase,
        children: [
          {
            path: 'overview',
            name: 'EquipmentDetailOverview',
            component: EquipmentDetailOverview
          }
        ]
      },
    ]
  }
]

export default routes
